<template>
	<div class="comp-u-container">
		<!-- 单图片上传 -->
		<div class="comp-u-pic-box" v-if="uploadType == '1'">
			<div class="comp-u-pics" style="width: 86px;">
				<div class="comp-u-pic" v-for="image in filePreList">
					<img :src="image.thumb == ''?image.url:image.thumb" alt="">
					<span class="comp-up-status" :class="{'comp-up-status-s': image.status == 1,'comp-up-status-f': image.status == 2}">{{image.msg}}</span>
				</div>
			</div>
			<div class="comp-u-buttons">
				<div class="comp-u-button comp-u-button-c"  @click="chooseImage">选择</div>
				<div class="comp-u-button" @click="uploadImage">上传</div>
				<input type="file" accept="image/*" style="display: none;" id="f-image">
			</div>
		</div>
		<!-- 多图片上传 -->
		<div class="comp-u-pics-box" v-else-if="uploadType == '2'">
			<div class="comp-u-pics">
				<div class="comp-u-pic" v-for="(image,key) in filePreList">
					<img :src="image.thumb == ''?image.url:image.thumb" alt="">
					<span class="comp-up-del" @click="delFile(key)">X</span>
					<span class="comp-up-status" :class="{'comp-up-status-s': image.status == 1,'comp-up-status-f': image.status == 2}">{{image.msg}}</span>
				</div>
			</div>
			<div class="comp-u-buttons">
				<div class="comp-u-button comp-u-button-c"  @click="chooseImages">选择图片</div>
				<div class="comp-u-button" @click="uploadImage">上传图片</div>
				<div class="comp-ub-info" id="comp-ub-info">图片限制{{maxPic}}张，已添加{{uploadFiles.length}}张，大小{{fileSize}}MB</div>
				<input type="file" multiple="multiple" accept="image/*" style="display: none;" id="f-images">
			</div>
		</div>
		<!-- 单视频上传 -->
		<div class="comp-u-video-box" v-else-if="uploadType == '3'">
			<div class="comp-u-video-wrap">
				<div class="comp-u-video" v-for="video in filePreList">
					<div class="comp-uv-box">
						<video :src="video.url" controls="controls"></video>
						<span class="comp-uv-status"  :class="{'comp-uv-status-s': video.status == 1,'comp-uv-status-f': video.status == 2}">{{video.msg}}</span>
					</div>
				</div>
			</div>
			<div class="comp-u-buttons">
				<div class="comp-u-button comp-u-button-c"  @click="chooseVideo">选择视频</div>
				<div class="comp-u-button" @click="uploadImage">上传视频</div>
				<input type="file" accept="video/*" style="display: none;" id="f-video">
			</div>
		</div>
		<!-- 单文件上传 -->
		<div class="comp-u-file-box" v-else-if="uploadType == '5'">
			<div class="comp-u-file-wrap">
				<div class="comp-u-file-item"  v-for="(image,key) in filePreList">
					<div class="comp-u-file-intro">
						<div class="comp-u-file-info">
							<ul>
								<li>{{image.name}}</li>
								<li>{{image.size}}</li>
							</ul>
						</div>
						<div class="comp-u-file-icon" :class="[{'comp-u-file-icon-txt': image.suffix === 'txt'},{'comp-u-file-icon-audio': image.suffix === 'mp3'},{'comp-u-file-icon-pdf': image.suffix === 'pdf'},{'comp-u-file-icon-ppt': image.suffix.indexOf('ppt') !== -1},{'comp-u-file-icon-doc': image.suffix.indexOf('doc') !== -1},{'comp-u-file-icon-xls': image.suffix.indexOf('xls') !== -1}]"></div>
					</div>
					<div class="comp-u-file-upload-status" :class="{'comp-u-upload-success': image.status == 1,'comp-u-upload-fail': image.status == 2}">{{image.msg}}</div>
					<div class="comp-u-file-del"  @click="delFile(key)">x</div>
				</div>
			</div>
			<div class="comp-u-buttons">
				<div class="comp-u-button comp-u-button-c"  @click="chooseFile">选择文件</div>
				<div class="comp-u-button" @click="uploadImage">上传文件</div>
				<div class="comp-ub-info" id="comp-ub-info" v-if="!hideInfo">共上传文件{{uploadFiles.length}}个，大小{{fileSize}}MB</div>
				<input type="file" multiple="multiple" style="display: none;" id="f-file">
			</div>
		</div>
		<!-- 音频上传 -->
		<div class="comp-u-audio-box" v-else-if="uploadType == '7'">
			<recorder-comp @recorder-call="recorderCall($event)" key="oss-img-recorder"></recorder-comp>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import OSS from 'ali-oss'
	import {getLoginId} from '../../functions/Common.js'
	import AppConfig from '../../../config/AppConfig.js'
	import RecorderComp from '../RecorderComp.vue'
	
	export default{
		 name: 'OssImgUploader',
		 components:{
			 RecorderComp
		 },
		 props:{
			 // 图片数量限制
			 maxPic:{
				 type: String,
				 default: '9'
			 },
			 uploadType:{
				 type: String,
				 default: '2'  // 1,单图上传；2，多图上传；3，单视频上传；5，文件上传；7，语音上传
			 },
			 uploadDir:{
				 type: String,
				 default: 'chatting'  // 值为chatting，cluster_chatting，moments
			 },
			 // 是否返回详细上传信息，false只返回文件路径数组，true返回对象数组
			 backDetail:{
				 type: Boolean,
				 default: false  // 
			 },
			 // 是否显示上传文件的详细信息
			 hideInfo:{
				 type: Boolean,
				 default: false  // 
			 }
		 },
		 data(){
			 return {
				 // 控制语音的录入的属性
				 audioStatus: '',
				 audioErrorMsg: '',
				 chunks:[],
				 mediaRecorder:null,
				 // 是否有了监听的事件
				 changeListener:false,
				 // 预览图
				 filePreList:[],
				 // 待传后的图片
				 uploadFiles:[],
				 // 已上传的图片
				 uploadedFiles: [],
				 // 允许上传的文件后缀，不包含图片，视频，语音
				 allowFileSuffix:['txt','pdf','xlsx','xls','docx','doc','pptx','ppt','mp3','mp4'],
				 // OSS相关
				 ossConfig:{
					 // oss基本配置
					 wanUrl: '',
					 root: 'uploads',
					 // 图片处理
					 thumb90: 'thumb_90',
					 thumbW200: 'thumb_w200',
					 // 允许的后缀
					 allowSuffix: ['jpg','png','jpeg','gif','mp4','mp3'],
					 // 文件类型对应关系
					 fileType2Suffix: {
						"text/plain":'txt',
						"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":'xlsx',
						"image/png":'png',
						"video/mp4":'mp4',
						"image/jpeg":'jpg',
						"image/gif":'gif',
						"audio/mp3":'mp3',
					}
				 },
				 // 额外的参数
				 extraParam:{
					 duration:0
				 }
			 }
		 },
		 methods:{
			 // 选择图片-单图
			 chooseImage(){
				 let __this = this
				 let fImage = document.getElementById("f-image")
				 fImage.click()
				 if(!__this.changeListener){
					 __this.changeListener = true
					 fImage.addEventListener('change',function(){
						 // 清空之前的文件信息
						__this.filePreList.splice(0)
						__this.uploadFiles.splice(0)
						__this.uploadedFiles.splice(0)
						let fileList = this.files
						// 处理文件
						if(fileList[0].type.indexOf('image') == 0){
							__this.uploadFiles.push({
								size: fileList[0].size,
								file: fileList[0]
							})
							let reader = new FileReader()
							reader.readAsDataURL(fileList[0])
							reader.onload = function(e){
								let newUrl = this.result
								__this.filePreList.push({
									url: newUrl,
									thumb: '',
									name:'',
									status: 0,
									size: 0,
									suffix: '',
									msg:'待上传'
								})
							}
						}
						fImage.value = ""
					 })
				 } 
			 },
			 
			 // 选择图片-多图
			 chooseImages(){
				 let __this = this
				 let fImage = document.getElementById("f-images")
				 fImage.click()
				 if(!__this.changeListener){
					 __this.changeListener = true
					 fImage.addEventListener('change',function(){
						let fileList = this.files
						let promise = Promise.resolve()
						for (let i = 0; i < fileList.length; i++) {
							// 判断大小是否超过限制
							if(__this.filePreList.length >= parseInt(__this.maxPic) || i > parseInt(__this.maxPic) -1){
								continue
							}
							promise = promise.then(()=>{
								return new Promise((resolve, reject)=>{
									// 处理文件
									if(fileList[i].type.indexOf('image') == 0){
										__this.uploadFiles.push({
											size: fileList[i].size,
											file: fileList[i]
										})
										let reader = new FileReader()
										reader.readAsDataURL(fileList[i])
										reader.onload = function(e){
											let newUrl = this.result
											__this.filePreList.push({
												url: newUrl,
												thumb: '',
												name:'',
												status: 0,
												size: 0,
												suffix: '',
												msg:'待上传'
											})
											resolve()
										}
									}else{
										resolve()
									}
								})
							})
						}
					 })
				 } 
			 },
			 
			 // 选择视频
			 chooseVideo(){
				 let __this = this
				 let fImage = document.getElementById("f-video")
				 fImage.click()
				 if(!__this.changeListener){
					 __this.changeListener = true
					 fImage.addEventListener('change',function(){
						 // 清空之前的文件信息
						__this.filePreList.splice(0)
						__this.uploadFiles.splice(0)
						__this.uploadedFiles.splice(0)
						let fileList = this.files
						// 处理文件
						if(fileList[0].type.indexOf('video') == 0){
							__this.uploadFiles.push({
								size: fileList[0].size,
								file: fileList[0]
							})
							let url
							if(window.createObjectURL !== undefined){
								url = window.createObjectURL(fileList[0])
							}else if (window.URL!=undefined) { // mozilla(firefox)
								url = window.URL.createObjectURL(fileList[0]) ;
							} else if (window.webkitURL!=undefined) { // webkit or chrome
								url = window.webkitURL.createObjectURL(fileList[0]) ;
							}
							__this.filePreList.push({
								url: url,
								thumb: '',
								name:'',
								status: 0,
								size: 0,
								suffix: '',
								msg:'待上传'
							})
						}
						fImage.value = ""
					 })
				 } 
			 },
			 
			 // 选择文件
			 chooseFile(){
				 let __this = this
				 let fFile = document.getElementById("f-file")
				 fFile.click()
				 if(!__this.changeListener){
					 __this.changeListener = true
					 fFile.addEventListener('change',function(){
						let fileList = this.files
						let error_msg = ''
						if(fileList.length === 0){
							CHAT_LAYER.msg('未选择文件，请重新上传！',{icon: 2})
							return
						}
						for (let i = 0; i < fileList.length; i++) {
							// 处理文件
							// 判断后缀
							let suffix = __this.getFileSuffix(fileList[i].name)
							if(__this.allowFileSuffix.indexOf(suffix) === -1){
								error_msg += fileList[i].name + '：格式不支持<br/>'
								continue
							}
							// 判断大小
							if(fileList[i].size >= 1024 * 1024 * 100){
								error_msg += fileList[i].name + '：大小超限，最大100MB<br/>'
								continue
							}
							__this.uploadFiles.push({
								size: fileList[i].size,
								file: fileList[i]
							})
							__this.filePreList.push({
								url: '',
								thumb: '',
								name: fileList[i].name,
								status: 0,
								size: __this.formatFileSize(fileList[i].size),
								suffix: suffix,
								msg:'待上传'
							})
						}
						// 提示错误信息
						if(error_msg !== ''){
							CHAT_LAYER.open({
								type: 0,
								title: '选择提醒',
								content: error_msg
							})
						}
						fFile.value = ''
					 })
				 } 
			 },
			 
			 // 上传图片
			 uploadImage(){
				 this.upload(this.uploadDir)
			 },
			 
			 // 删除图片
			 delFile(index){
				 this.filePreList.splice(index,1)
				 this.uploadFiles.splice(index,1)
				 this.uploadedFiles.splice(index,1)
			 },
			 
			 // OSS相关模块-获取密钥
			 requestKS(callback){
				let _this = this;
				// 读取缓存
				let cacheParam = localStorage.getItem('yswl_oss');
				if (cacheParam !== null){
					 cacheParam = JSON.parse(cacheParam);
					 if(new Date(cacheParam.expiration).getTime() > new Date().getTime()){
						 let client = new OSS(cacheParam);
						 _this.ossConfig.wanUrl = cacheParam.wanUrl;
						 // 回调
						 callback(client);
						 return;
					 }
				 }
				 // 重新获取
				 axios.get(AppConfig.host+'/api/api/getOssConfig?weiI=browser-'+getLoginId()).then(function(data){
					 if(data.status !== 200){
						 callback(false);
						 return false;
					 }
					 let result = data.data
					 let param = {
					 	accessKeyId: result.AccessKeyId,
					 	accessKeySecret: result.AccessKeySecret,
					 	stsToken: result.SecurityToken,
					 	endpoint: result.endpoint,
					 	bucket: result.bucket,
					 	expiration:result.Expiration,
					 	wanUrl:result.wanUrl,
						secure: true
					 };
					 let client = new OSS(param);
					 _this.ossConfig.wanUrl = result.wanUrl;
					 // 缓存数据
					 localStorage.setItem('yswl_oss',JSON.stringify(param));
					 // 回调
					 callback(client);
				 },function(error){
					 callback(false)
					 return false
				 })
			 },
			 
			 // OSS相关模块-上传文件
			 upload(dir,thumb) {
				 let u_res = []
				 let imgSuffix = ['jpg','png','jpeg']
				 if (thumb === undefined || thumb === ""){
					 thumb = this.ossConfig.thumb90
				 }
				 if (dir === undefined || dir === ""){
					 dir = 'images'
				 }
				 let _this = this
				 this.requestKS(client=>{
					 if(client === false){
						 return false
					 }
					 // 同步执行上传
					 let promise = Promise.resolve();
					 for (let i = 0;i<_this.uploadFiles.length;i++){
						 promise = promise.then(()=>{
							 return new Promise((resolve, reject)=>{
								 let file = _this.uploadFiles[i].file
								 if((file instanceof File) === false){
									 resolve()
									 return
								 }
								 // 处理不支持类型文件
								 // let suffix = _this.ossConfig.fileType2Suffix[file.type]
								 let suffix = _this.getFileSuffix(file.name)
								 if (_this.ossConfig.allowSuffix.indexOf(suffix) === -1 && _this.allowFileSuffix.indexOf(suffix) === -1) {
									 _this.uploadFail(i,'不支持的文件')
									 resolve();
									 return;
								 }
								 let filePath = _this.createPath(suffix,dir);
								 // 上传中提示
								 let preImage = _this.filePreList[i]
								 preImage.msg = '上传中...'
								 _this.filePreList.splice(i,1,preImage)
								 //filePath表示上传的object name , file表示上传的文件
								 client.multipartUpload(filePath, file,{}).then(function (oss_result) {
									 let path = _this.ossConfig.wanUrl + filePath;
									 let thumbSave = path;
									 if (imgSuffix.indexOf(suffix) !== -1){
										 thumbSave = path + '?x-oss-process=style/' + thumb;
									 }
									 if (oss_result.res !== undefined && oss_result.res.status === 200 && oss_result.res.statusCode === 200){
										 let orgUploadFiles = _this.uploadFiles[i]
										 orgUploadFiles.file = i;
										 _this.uploadFiles.splice(i,1,orgUploadFiles)
										 let preImage = _this.filePreList[i]
										 preImage.status = 1
										 preImage.msg = '上传成功'
										 preImage.thumb = thumbSave
										 _this.filePreList.splice(i,1,preImage)
										 let uploadBackData = {
											 name: file.name,
											 size: file.size,
											 suffix:suffix,
											 path: path
										 }
										 if(_this.uploadedFiles[i] === undefined){
											_this.uploadedFiles.push(uploadBackData)
										 }else{
											 _this.uploadedFiles.splice(i,1,uploadBackData)
										 }	 
									 }else{
										 _this.uploadFail(i,'上传失败')
									 }
									 resolve();
								 }).catch(function (err) {
									 _this.uploadFail(i,'服务器异常')
									 resolve();
								 });
							 })
						 })
					 }
					 // 向父级回调数据
					 promise.then((resolve, reject)=>{
						_this.emitData()
					 })
				 });
			 },
			 
			 // OSS相关模块-生成上传文件路径
			 createPath(suffix,dir) {
				 if (suffix === undefined || suffix === ''){
					 suffix = 'jpg';
				 }
				 if (dir === undefined || dir === ''){
					 dir = 'files';
				 }
				 let date = new Date();
				 let month = date.getMonth() + 1;
				 let day  = date.getDate();
				 if (month < 10){
					 month = '0'+month;
				 }
				 if (day < 10){
					 day =  '0' + day;
				 }
				 let file_name = (date.getTime() + '_' + this.random(10000,99999)).split('').reverse().join('');
				 return this.ossConfig.root + '/' + dir + '/' + date.getFullYear() + month + '/' + day + '/' + file_name + '.' + suffix;
			 },
		 
			 // OSS相关模块-生成随机数
			 random(min,max) {
				 return Math.ceil(Math.random() * (max - min)) + min;
			 },
			 
			 // OSS相关模块-上传失败处理
			 uploadFail(index,msg){
				 let preImage = this.filePreList[index]
				 preImage.status = 2
				 preImage.msg = msg
				 this.filePreList.splice(index,1,preImage)
				 if(this.uploadedFiles[index] === undefined){
				 	this.uploadedFiles.push({})
				 }	
			 },
			 
			 // 返回文件后缀
			 getFileSuffix(fileName){
				 let index = fileName.lastIndexOf(".")
				 if(index === -1){
					 return ''
				 }
				 return fileName.substring(index+1).toLocaleLowerCase()
			 },
			 
			 // 反射上传结果给父级组件
			 emitData(){
				 if(this.backDetail){
					 let backData = this.uploadedFiles
					 if(this.extraParam.duration > 0){
						 backData[0].duration = this.extraParam.duration
					 } 
					 this.$emit("oss-upload-call",backData)
				 }else{
					 let files = []
					 for(let i in this.uploadedFiles){
						 let path = this.uploadedFiles[i].path
						 if(path === undefined){
							 path = ''
						 }
						 files.push(path)
					 }
					 this.$emit("oss-upload-call",files)
				 }
			 },
			 
			 // 格式化文件大小
			 formatFileSize(size){
				 let fromatStr
				 if(size < 1024){
					 fromatStr = size + 'B'
				 }else if(size < 1024 * 1024){
					 fromatStr = Math.ceil(100*size/1024) / 100 + 'KB'
				 }else{
					 fromatStr = Math.ceil(100*size/1024/1024) / 100 + 'MB'
				 }
				 return fromatStr
			 },
			 
			 // 录音回调数据
			 recorderCall(data){
				 this.extraParam.duration = data.duration
				// 保存文件对象，准备上传
				 this.uploadFiles.push({
					size: data.file.size,
					file: data.file
				 })
				 this.filePreList.push({
					url: '',
					thumb: '',
					name:'',
					status: 0,
					size: 0,
					suffix: 'mp3',
					msg:'待上传'
				 })
				 this.uploadImage()
			 }
		 },
		 computed:{
			 // 计算文件总大小
			 fileSize(){
				 let size = 0
				 for (var i = 0; i < this.uploadFiles.length; i++) {
				 	size += this.uploadFiles[i].size
				 }
				 return Math.ceil(100*size/1024/1024) / 100
			 }
		 },
		 
		 mounted() {
			this.extraParam = {
				start: 0,
				end: 0
			}
		 },
		 
		 // 组件销毁时处理的逻辑
		 destroyed() {
			 // 关闭录音
			 if(this.mediaRecorder !== undefined && this.mediaRecorder !== null){
				 if(this.mediaRecorder.state !== 'inactive'){
					 this.mediaRecorder.stop()
				 }
				 if(this.mediaRecorder.stream !== undefined){
					 this.mediaRecorder.stream.getTracks().forEach(function(track){
						 track.stop()
					 })
				 }
				 this.mediaRecorder = null
			 }
		 }
	}
</script>

<style>
	.comp-u-upload-success{
		color: #42B983 !important;
	}
	.comp-u-upload-fail{
		color: #ff5500 !important;
	}
	.comp-u-container{
		min-height: 100px;
		max-height: 300px;
		overflow-x: hidden;
		overflow-y: auto;
		margin: 10px;
	}
	.comp-u-pics{
		height: auto;
		min-height: 86px;
		border: 1px solid #e3e3e3;
		border-radius: 4px;
		margin: 5px;
		padding: 3px;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}
	.comp-u-pics .comp-u-pic{
		width: 80px;
		height: 80px;
		background-color: #dfdfdf;
		margin: 3px;
		position: relative;
	}
	.comp-u-pic img{
		width: 100%;
		height: 100%;
	}
	.comp-u-pic .comp-up-del{
		display: block;
		position: absolute;
		top: 0;
		right: 0;
		background-color: #ff5500;
		color: #FFFFFF;
		font-size: 12px;
		width: 16px;
		height: 16px;
		line-height: 16px;
		text-align: center;
		cursor: pointer;
	}
	.comp-u-pic .comp-up-status{
		display: block;
		position: absolute;
		left: 0;
		bottom: 0;
		right: 0;
		background-color: #222222;
		color: #FFFFFF;
		text-align: center;
		font-size: 12px;
		height: 16px;
		line-height: 16px;
		opacity: .8;
	}
	.comp-u-pic .comp-up-status-s{
		color: #42B983 !important;
	}
	.comp-u-pic .comp-up-status-f{
		color: #ff5500 !important;
	}
	.comp-u-buttons{
		width: 100%;
		height: 24px;
		line-height: 24px;
		padding: 5px 0;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}
	.comp-u-buttons .comp-u-button{
		height: 24px;
		padding: 0 7px;
		margin: 0 5px;
		background-color: #2296dd;
		cursor: pointer;
		border-radius: 2px;
		color: #ebebeb;
	}
	.comp-u-buttons .comp-u-button-c{
		background-color: #42B983;
	}
	.comp-u-buttons .comp-ub-info{
		margin: 0 5px;
		font-size: 12px;
	}
	.comp-u-video-wrap{
		min-height: 94px;
		padding: 5px;
	}
	.comp-u-video{
		width: 300px;
	}
	.comp-u-video .comp-uv-box{
		width: 100%;
		height: auto;
	}
	.comp-uv-box video{
		width: 100%;
		display: block;
		outline: none;
	}
	.comp-uv-box .comp-uv-status{
		display: block;
		text-align: center;
		background-color: #000000;
		color: #FFFFFF;
		text-align: center;
		font-size: 12px;
		height: 20px;
		line-height: 20px;
		opacity: .8;
	}
	.comp-uv-box .comp-uv-status-s{
		color: #42B983 !important;
	}
	.comp-uv-box .comp-uv-status-f{
		color: #ff5500 !important;
	}
	.comp-u-file-wrap{
		min-height: 72px;
		padding: 5px;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}
	.comp-u-file-wrap .comp-u-file-item{
		margin-right: 8px;
		margin-bottom: 8px;
		background-color: #FFFFFF;
		padding: 5px;
		width: 210px;
		overflow: hidden;
		border-radius: 4px;
		position: relative;
	}
	.comp-u-file-item .comp-u-file-intro{
		word-break: keep-all;
		display: flex;
		justify-content: space-around;
		align-items: center;
		width: 100%;
	}
	.comp-u-file-intro .comp-u-file-info{
		width: 0;
		flex-grow: 1;
		overflow: hidden;
	}
	.comp-u-file-info ul li{
		line-height: 20px;
		height: 20px;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.comp-u-file-info ul li:last-child{
		font-size: 12px;
		color: #999999;
	}
	.comp-u-file-intro .comp-u-file-icon{
		width: 32px;
		height: 32px;
		margin-left: 5px;
		background-image: url(../../assets/img/msg-file.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 24px auto;
	}
	.comp-u-file-intro .comp-u-file-icon-txt{
		background-image: url(../../assets/img/msg-txt.png) !important;
	}
	.comp-u-file-intro .comp-u-file-icon-ppt{
		background-image: url(../../assets/img/msg-ppt.png) !important;
	}
	.comp-u-file-intro .comp-u-file-icon-pdf{
		background-image: url(../../assets/img/msg-pdf.png) !important;
	}
	.comp-u-file-intro .comp-u-file-icon-doc{
		background-image: url(../../assets/img/msg-doc.png) !important;
	}
	.comp-u-file-intro .comp-u-file-icon-xls{
		background-image: url(../../assets/img/msg-xls.png) !important;
	}
	.comp-u-file-intro .comp-u-file-icon-audio{
		background-image: url(../../assets/img/msg-audio.png) !important;
	}
	.comp-u-file-item .comp-u-file-upload-status{
		font-size: 12px;
		line-height: 20px;
		border-top: 1px solid #EEEEEE;
	}
	.comp-u-file-item .comp-u-file-del{
		position: absolute;
		top: 0;
		right: 0;
		cursor: pointer;
		width: 14px;
		height: 14px;
		line-height: 14px;
		text-align: center;
		color: red;
		border-radius: 50%;
		box-shadow: -1px 1px 1px 1px #ef0e0e;
		background-color: #FFFFFF;
	}
</style>
